import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { AuthService } from './../core-services/authentication/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return from(this.authService.getAccessToken()).pipe(
      switchMap((token: string) => {
        //console.log('Auth Token in Interceptor: ', token);
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        });
        return next.handle(clonedReq);
      })
    );
  }
}
